import Duty from "./Duty";

const JobInfo = (props)=>
{
    const { company, dates, duties, title } = props;
    //console.log(duties);
    return (
    <article className="job-info">
        <h3>{title}</h3>
        <h4>{company}</h4>
        <p className="job-date">{dates}</p>
        {
            duties.map((duty, index) => 
            {
                return (<Duty key = {index} duty = {duty}/>);
            })
        }
    </article>);
}
export default JobInfo;